export const SIPARIS_TUR = {
  MOBIL: 3,
  CALL_CENTER:6
}